import { motion } from "framer-motion";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-obsidian scroll-mt-16"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-4"
          >
            <p className="text-xs uppercase tracking-[0.25em] text-gold mb-4">
              About Us
            </p>
            <h2 className="font-serif font-light text-3xl sm:text-4xl text-white tracking-tight leading-tight">
              Built for people who value time above everything
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="lg:col-span-7 lg:col-start-6"
          >
            <p className="text-base sm:text-lg text-white/70 font-light leading-relaxed">
              Aero Vista Club is a private aviation and luxury asset house
              serving business travellers and executives. We handle aircraft
              charter and acquisition, yacht brokerage and physical bullion —
              quietly, precisely, and always on your side of the table.
            </p>
            <p className="mt-6 text-base sm:text-lg text-white/70 font-light leading-relaxed">
              Every enquiry is answered by a person, not a queue. One
              conversation is usually enough to know whether we are the right
              partner for your next aircraft, yacht or asset purchase.
            </p>
            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-px bg-white/5 border border-white/5 rounded-sm overflow-hidden">
              {[
                { k: "01", v: "Discreet by default" },
                { k: "02", v: "One dedicated broker" },
                { k: "03", v: "Air, sea & bullion desks" },
              ].map((item) => (
                <div
                  key={item.k}
                  data-testid={`about-principle-${item.k}`}
                  className="bg-obsidian p-6"
                >
                  <p className="text-[10px] uppercase tracking-[0.25em] text-gold mb-2">
                    {item.k}
                  </p>
                  <p className="text-sm text-white/80 font-light">{item.v}</p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
